import api from '@lib/api'
import { useQuery } from '@tanstack/react-query'

interface GenerateAuthQrTokenResponse {
	token: string
	expiresAt: number
}

export function useGenerateAuthQrToken() {
	return useQuery<GenerateAuthQrTokenResponse>({
		queryKey: ['qr-token'],
		queryFn: async () => {
			const { data } = await api.post<GenerateAuthQrTokenResponse>('auth/qr-code/generate')
			return data
		},
		refetchInterval: 1000 * 60 * 4, // Refetch every 4 minutes (before 5 min expiry)
		staleTime: 1000 * 60 * 4,
	})
}
